import { globalSearchTypes } from "../actions/globalSearch";

const initialState = {
  isLoading: false,
  query: '',
  navigateSearchPopUp: false,
  isGlobalSearchVisible: false,
  result: {
    totalDevices: 0,
    devices: [],
    organizations: [],
    locations: []
  },
  error: null,
};

const globaleSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case globalSearchTypes.GLOBAL_SEARCH_REQUEST:
      return {
        ...state,
        query: action.payload,
        isLoading: true,
      };
    case globalSearchTypes.GLOBAL_SEARCH_POP_UP_REQUEST:
      return {
        ...state,
        navigateSearchPopUp: action.payload,
        isLoading: true,
      };
    case globalSearchTypes.GLOBAL_SEARCH_MODEL_REQUEST:
      return {
        ...state,
        isGlobalSearchVisible: action.payload,
        isLoading: true,
      };
    case globalSearchTypes.GLOBAL_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        result: action.payload,
        error: null
      };
    case globalSearchTypes.GLOBAL_SEARCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        result: {
          devices: [],
          organizations: [],
          locations: []
        },
        error: action.payload,
      };
    default:
      return state;
  }
};

export default globaleSearchReducer;